import * as React from "react";
import VingleDialog, { VingleDialogTypes } from "../../../vingleDialog";

const styles = require("./confirmModal.scss");

export enum CONFIRM_RESPONSE {
  OK = "OK",
  CANCEL = "CANCEL",
}

interface IProps {
  open: boolean;
  onRequestClose: () => void;
  onResponseCallback: (response: CONFIRM_RESPONSE) => void;
  title?: React.ReactNode;
  message?: React.ReactNode;
  cancelButtonText?: React.ReactNode;
  submitButtonText?: React.ReactNode;
}

const ConfirmModal = ({
  open,
  title,
  message,
  cancelButtonText,
  submitButtonText,
  onRequestClose,
  onResponseCallback,
}: IProps) => {
  const onCloseHandler = () => {
    onResponseCallback(CONFIRM_RESPONSE.CANCEL);
    onRequestClose();
  };

  const submitButtonHandler = () => {
    onResponseCallback(CONFIRM_RESPONSE.OK);
    onRequestClose();
  };

  return (
    <VingleDialog
      open={open}
      type={VingleDialogTypes.MODAL}
      onRequestClose={onCloseHandler}
      title={title}
      cancelButtonText={cancelButtonText}
      submitButtonText={submitButtonText}
      onRequestSubmit={submitButtonHandler}
    >
      <div className={styles.messageBody}>{message}</div>
    </VingleDialog>
  );
};

export default ConfirmModal;
